import type { Pricing } from "~/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "~/components/ui/tabs";
import { PlaceOverview, type PlaceOverviewProps } from "~/components/landing/PlaceOverview";
import { PlacePricing } from "~/components/place/PlacePricing";

interface PlaceDetailTabsProps extends PlaceOverviewProps {
  pricing: Pricing | null | undefined;
  className?: string;
}

export function PlaceDetailTabs({ pricing, className, ...overviewProps }: PlaceDetailTabsProps) {
  if (!pricing || pricing.free || pricing.prices.length === 0) {
    return (
      <div className={className}>
        <PlaceOverview {...overviewProps} />
      </div>
    );
  }

  return (
    <Tabs defaultValue="overview" className={className}>
      <TabsList>
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="prices">Prices</TabsTrigger>
      </TabsList>
      <TabsContent value="overview">
        <PlaceOverview {...overviewProps} />
      </TabsContent>
      <TabsContent value="prices">
        <PlacePricing pricing={pricing} />
      </TabsContent>
    </Tabs>
  );
}
